import { Button } from '@navi/web-ui/lib/primitives';
import { ThreeDotVerticalIcon } from '@navi/web-ui/lib/icons';
import { Typography } from '@navi/web-ui/lib/primitives';
import { Popper, PopperTrigger, PopperContent } from '@cp/src/components/Popper/Popper';
import { useDispatch, useSelector } from 'react-redux';
import styles from './index.module.scss';
import { deleteCiuAllocationConfigById, getAllCiuAllocationConfigs } from './action';
import { AllocationData } from './types';
import { RootState } from '@cp/src/store';

interface AllocationActionsCellProps {
  row: AllocationData;
  onEdit: (id: string) => void;
  onDuplicate: (id: string) => void;
}

const AllocationActionsCell = (props: AllocationActionsCellProps) => {
  const { row, onEdit, onDuplicate } = props;
  const dispatch = useDispatch();

  const pageSize = useSelector((state: RootState) => state.ciuAllocations.pagination?.pageSize);
  const pageIndex = useSelector((state: RootState) => state.ciuAllocations.pagination?.pageIndex);

  const businessVertical = useSelector((store: RootState) => store?.common?.agentBusinessVertical);

  const handleOnDuplicate = (closePopper: () => void) => {
    onDuplicate(row.id);
    closePopper();
  };

  const handleOnDelete = (closePopper: () => void) => {
    handleDelete();
    closePopper();
  };

  const handleDelete = () => {
    dispatch(
      deleteCiuAllocationConfigById(row.id, businessVertical, () => {
        dispatch(getAllCiuAllocationConfigs(pageIndex, pageSize, businessVertical));
      })
    );
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="text"
        size="small"
        onClick={() => onEdit(row.id)}
        className={styles.editButton}
      >
        <Typography variant="h4" color="var(--navi-color-blue-base)">
          Edit
        </Typography>
      </Button>
      <Popper placement="left-end" crossAxisOffset={85} mainAxisOffset={-2}>
        <PopperTrigger>
          <Button variant="text" size="small" className={styles.editButton}>
            <ThreeDotVerticalIcon width={20} height={20} color={'var(--navi-color-blue-base)'} />
          </Button>
        </PopperTrigger>
        <PopperContent
          noHeader
          arrowColor="transparent"
          className="bg-white rounded-lg shadow-lg w-[150px] p-0 z-[var(--z-index-ameyo-tooltip)]"
        >
          {({ closePopper }) => (
            <div className="flex flex-col">
              <Button
                variant="text"
                size="small"
                className="justify-start px-4 py-2 hover:bg-[var(--navi-color-gray-bg-secondary)] rounded-none border-b"
                onClick={() => handleOnDuplicate(closePopper)}
              >
                <Typography variant="p3" color="var(--navi-color-gray-c2)">
                  Duplicate
                </Typography>
              </Button>
              <Button
                variant="text"
                size="small"
                className="justify-start px-4 py-2 hover:bg-[var(--navi-color-gray-bg-secondary)] rounded-none"
                onClick={() => handleOnDelete(closePopper)}
              >
                <Typography variant="p3" color="var(--navi-color-gray-c2)">
                  Delete
                </Typography>
              </Button>
            </div>
          )}
        </PopperContent>
      </Popper>
    </div>
  );
};

export default AllocationActionsCell;
